import React from 'react';

import { Button as AntdButton } from 'antd';

import { UserDtoProfileEnum } from 'lib_api/lib/api/gen';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';
import {
  DashboardComptesUtilisateursFilterForm,
  FilterDashboardComptesUtilisateurs,
} from 'components/Comptes/Dashboard/DashboardHeader/types';

interface FormActionProps {
  setFilter: (value: FilterDashboardComptesUtilisateurs) => void;
  userProfile: UserDtoProfileEnum | undefined;
  filter?: FilterDashboardComptesUtilisateurs;
}

export function FormFooter({
  setFilter,
  userProfile,
  filter,
}: FormActionProps): React.ReactElement {
  const context = useBaseFormContext<DashboardComptesUtilisateursFilterForm>();

  function resetFilter() {
    const values = context.getFieldsValue();
    const isUserAdminFonctionnel =
      userProfile === UserDtoProfileEnum.ADMIN_FONCTIONNEL;
    context.setFieldsValue({
      searchCompte: undefined,
      username: undefined,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      userType: isUserAdminFonctionnel ? undefined : values.userType,
      entiteRattachement: isUserAdminFonctionnel
        ? undefined
        : values.entiteRattachement,
      gestionnaireLocal: undefined,
    });
  }

  function constructFilter() {
    const values = context.getFieldsValue();

    const isUserAdminFonctionnel =
      userProfile === UserDtoProfileEnum.ADMIN_FONCTIONNEL;

    const filtered: FilterDashboardComptesUtilisateurs = {
      searchCompte: values.searchCompte,
      username: values.username,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      userType: values.userType,
      entiteRattachement: isUserAdminFonctionnel
        ? values.entiteRattachement?.value
        : filter?.entiteRattachement,
      gestionnaireLocal: values.gestionnaireLocal,
    };
    return filtered;
  }

  return (
    <div className={'form-footer-container'}>
      <AntdButton onClick={resetFilter}>Réinitialiser</AntdButton>
      <AntdButton type="primary" onClick={() => setFilter(constructFilter())}>
        Rechercher
      </AntdButton>
    </div>
  );
}
